import PropTypes from 'prop-types';
import { useDownloadProgram } from './DownloadProgramContext';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function DownloadProgramLink({
  children,
}) {
  const { onShowModal } = useDownloadProgram();

  return (
    <button
      className="font-bold text-lg text-gray-900 hover:text-gray-700 text-center focus:outline-none"
      onClick={onShowModal}
      type="button"
    >
      {children}        
    </button>
  );
}

DownloadProgramLink.defaultProps = defaultProps;
DownloadProgramLink.propTypes = propTypes;
